export default function isPreRendering() {
    return navigator.userAgent === 'ReactSnap';
};